import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { TelegramProvider } from './telegram/TelegramProvider'
import { ErrorBoundary } from './components/ErrorBoundary'
import { CHUNK_RELOAD_KEY } from './lib/lazy-with-retry'
import './styles/globals.css'

// Сбрасываем флаг авто-reload после успешной загрузки приложения
try {
  sessionStorage.removeItem(CHUNK_RELOAD_KEY)
} catch {
  // sessionStorage может быть недоступен
}

// Vite кидает это событие при провале preload динамического модуля
window.addEventListener('vite:preloadError', ((event: Event) => {
  event.preventDefault()
  try {
    if (!sessionStorage.getItem(CHUNK_RELOAD_KEY)) {
      sessionStorage.setItem(CHUNK_RELOAD_KEY, '1')
      window.location.reload()
    }
  } catch {
    window.location.reload()
  }
}) as EventListener)

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <TelegramProvider>
            <App />
          </TelegramProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>
)
